import styles from './LastSearch.less';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import { lastSearchClicked } from 'store/lastSearch/lastSearch';
import { ScreenReaderOnly } from 'seek-style-guide/react';
import { SearchIcon, ChevronIcon } from 'seek-style-guide/react';
import QualifiedLink from 'QualifiedLink/QualifiedLink';

const mapStateToProps = ({ lastSearch }) => ({
  query: lastSearch.query,
  summary: lastSearch.summary
});

const mapDispatchToProps = dispatch => ({
  onLinkClick: () => dispatch(lastSearchClicked())
});

@connect(mapStateToProps, mapDispatchToProps)
export default class LastSeach extends Component {

  static propTypes = {
    query: PropTypes.object.isRequired,
    summary: PropTypes.string.isRequired,
    onLinkClick: PropTypes.func.isRequired
  };

  render() {
    const { query, summary, onLinkClick } = this.props;

    return (
      <div>
        <ScreenReaderOnly>Last Search: </ScreenReaderOnly>
        <QualifiedLink
          onClick={onLinkClick}
          className={styles.link}
          path="/jobs"
          params={query}
          title={`Last Search: ${summary}`}
          data-automation="lastSearchLink">
          <SearchIcon className={styles.searchIcon} svgClassName={styles.searchSvg} />
          <span className={styles.summaryContainer}>
            <span className={styles.summary} data-automation="lastSearchSummary">
              <span className={styles.summaryOutline}>
                { summary }
              </span>
            </span>
            <ChevronIcon
              direction="right"
              className={styles.chevronIcon}
              svgClassName={styles.chevronSvg}
            />
          </span>
        </QualifiedLink>
      </div>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/Search/components/SearchBar/components/LastSearch/LastSearch.js
 **/